	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Resource.Texture2D;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-fundamental/ref/Resource/Texture2D.js
// module id = 23
// module chunks = 0